import React from 'react';
import { TextField, Box } from '@mui/material';

/**
 * ColorInput Component
 *
 * A specialized input field for color values with a color preview box
 */
const ColorInput = ({ name, label, value, onChange, fullWidth = true }) => {
  return (
    <TextField
      name={name}
      label={label}
      fullWidth={fullWidth}
      variant="outlined"
      value={value}
      onChange={onChange}
      InputProps={{
        startAdornment: (
          <Box
            sx={{
              width: 20,
              height: 20,
              backgroundColor: value,
              borderRadius: 0.5,
              mr: 1,
              border: '1px solid #ccc',
            }}
          />
        ),
      }}
    />
  );
};

export default ColorInput;
